import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-curriculumO",
  "use": "icon-curriculumO-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-curriculumO\"><defs><style type=\"text/css\"></style></defs><path d=\"M873.569524 0h-93.866667v430.86019l-105.252571-76.190476-105.252572 76.190476V0H137.118476C75.068952 0 24.380952 50.054095 24.380952 111.323429v801.353142C24.380952 973.945905 75.068952 1024 137.118476 1024h736.475429c62.049524 0 112.737524-50.054095 112.737524-111.323429V111.323429C986.331429 50.054095 935.619048 0 873.569524 0zM197.315048 831.75619c0 24.405333-16.822857 44.495238-37.571048 44.495239-20.72381 0-37.571048-20.089905-37.571048-44.495239V192.365714c0-24.429714 16.822857-44.495238 37.546667-44.495238 20.74819 0 37.595429 20.065524 37.595429 44.495238v639.366096z\" p-id=\"30981\" fill=\"#FF6633\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/curriculumO.svg
// module id = UJih
// module chunks = 81